import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "../Form";
import { perksSelector, jobSelector } from "../../redux/selectors";
import { perksQuestions } from "../../utils/constants";
import { setPerks } from "../../redux/actions/perks";

const Perks = () => {
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { perks } = useSelector(perksSelector);
  const { job } = useSelector(jobSelector);

  const handleChange = (formData: any, isValid: boolean) => {
    dispatch(
      setPerks({
        ...perks,
        formData: { ...perks.formData, ...formData, jobId: job.id },
        isConfigured: isValid,
      })
    );
  };

  useEffect(() => {
    if (!perks.isConfigured) {
      setError("You need to select atleast one preference from each section");
    } else {
      setError("");
    }
  }, [perks]);

  return (
    <>
      <p className="form-title">Perks</p>
      <Form
        id="perks"
        questions={perksQuestions}
        handleChange={handleChange}
        formData={perks.formData}
      />
      <p className="form-error-message">{error}</p>
    </>
  );
};

export default Perks;
